var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g2, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldLavTube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 97,
    viewBox: "0 0 63 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4432 26.188V13.5885C30.5551 11.7534 29.5704 9.33647 29.5704 7.61327C29.5704 5.89007 27.5563 6.00197 27.5563 6.00197H21.693H20.7754H14.9121C14.9121 6.00197 12.8979 5.89007 12.8979 7.61327C12.8979 9.33647 11.9133 11.7534 12.0252 13.5885V26.1656C12.0252 26.1656 11.6895 28.6945 13.9721 28.6945H20.753C21.3125 28.6945 21.6706 28.6945 21.6706 28.6945H28.4515C30.7565 28.6945 30.3985 26.1656 30.3985 26.1656L30.4432 26.188Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7141_4729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 28,
    width: 18,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.729 28.6499H12.7656V92.632H29.729V28.6499Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7141_4729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6202 22.2939H20.8593C17.1638 22.2939 14.168 25.2898 14.168 28.9853V84.3514C14.168 88.047 17.1638 91.0428 20.8593 91.0428H21.6202C25.3158 91.0428 28.3116 88.047 28.3116 84.3514V28.9853C28.3116 25.2898 25.3158 22.2939 21.6202 22.2939Z",
    fill: "white",
    stroke: "#555555",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2461 9.51562V25.0244",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4102 11.4175V25.024",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0547 11.4175V25.024",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6139 37.627H17.3008V80.2546H27.6139",
    stroke: "#9E8959",
    strokeWidth: 1.37509
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 50.975L23.0273 51.3706L27.8101 51.3706L27.8101 50.975L23.0273 50.975Z",
    fill: "#004137"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 50.5298L23.0273 50.7275L27.8101 50.7275L27.8101 50.5298L23.0273 50.5298Z",
    fill: "#004137"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 49.8867L23.0273 50.0845L27.8101 50.0845L27.8101 49.8867L23.0273 49.8867Z",
    fill: "#004137"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 48.8242L23.0273 49.022L27.8101 49.022L27.8101 48.8242L23.0273 48.8242Z",
    fill: "#004137"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 47.9829L23.0273 48.1807L27.8101 48.1807L27.8101 47.9829L23.0273 47.9829Z",
    fill: "#004137"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 46.9203L22.9961 47.3159L27.7788 47.3159L27.7788 46.9203L22.9961 46.9203Z",
    fill: "#004137"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 46.4506L23.0273 46.6484L27.8101 46.6484L27.8101 46.4507L23.0273 46.4506Z",
    fill: "#004137"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 45.2144L22.9961 45.8325L27.7788 45.8325L27.7788 45.2144L22.9961 45.2144Z",
    fill: "#004137"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 44.1269L23.0273 44.3247L27.8101 44.3247L27.8101 44.1269L23.0273 44.1269Z",
    fill: "#004137"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 44.5707L23.0273 44.9663L27.8101 44.9663L27.8101 44.5707L23.0273 44.5707Z",
    fill: "#004137"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 43.2857L23.0273 43.9038L27.8101 43.9038L27.8101 43.2857L23.0273 43.2857Z",
    fill: "#004137"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 42.2231L23.0273 42.6187L27.8101 42.6187L27.8101 42.2231L23.0273 42.2231Z",
    fill: "#004137"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 41.7524L23.0273 41.9502L27.8101 41.9502L27.8101 41.7524L23.0273 41.7524Z",
    fill: "#004137"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 60.601L23.0273 60.9966L27.8101 60.9966L27.8101 60.601L23.0273 60.601Z",
    fill: "#004137"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 60.1557L23.0273 60.3535L27.8101 60.3535L27.8101 60.1557L23.0273 60.1557Z",
    fill: "#004137"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 59.5131L23.0273 59.7109L27.8101 59.7109L27.8101 59.5132L23.0273 59.5131Z",
    fill: "#004137"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 58.4497L23.0273 58.6475L27.8101 58.6475L27.8101 58.4497L23.0273 58.4497Z",
    fill: "#004137"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 57.6093L23.0273 57.8071L27.8101 57.8071L27.8101 57.6093L23.0273 57.6093Z",
    fill: "#004137"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 56.5458L22.9961 56.9414L27.7788 56.9414L27.7788 56.5458L22.9961 56.5458Z",
    fill: "#004137"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 56.0771L23.0273 56.2749L27.8101 56.2749L27.8101 56.0771L23.0273 56.0771Z",
    fill: "#004137"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 54.8409L22.9961 55.459L27.7788 55.459L27.7788 54.8409L22.9961 54.8409Z",
    fill: "#004137"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 53.7534L23.0273 53.9512L27.8101 53.9512L27.8101 53.7534L23.0273 53.7534Z",
    fill: "#004137"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 54.1972L23.0273 54.5928L27.8101 54.5928L27.8101 54.1972L23.0273 54.1972Z",
    fill: "#004137"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 52.9117L23.0273 53.5298L27.8101 53.5298L27.8101 52.9117L23.0273 52.9117Z",
    fill: "#004137"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 51.849L23.0273 52.2446L27.8101 52.2446L27.8101 51.849L23.0273 51.849Z",
    fill: "#004137"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 51.3789L23.0273 51.5767L27.8101 51.5767L27.8101 51.3789L23.0273 51.3789Z",
    fill: "#004137"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 70.2265L23.0273 70.6221L27.8101 70.6221L27.8101 70.2265L23.0273 70.2265Z",
    fill: "#004137"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 69.7812L23.0273 69.979L27.8101 69.979L27.8101 69.7812L23.0273 69.7812Z",
    fill: "#004137"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 69.1386L23.0273 69.3364L27.8101 69.3364L27.8101 69.1386L23.0273 69.1386Z",
    fill: "#004137"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 68.0756L23.0273 68.2734L27.8101 68.2734L27.8101 68.0757L23.0273 68.0756Z",
    fill: "#004137"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 67.2343L23.0273 67.4321L27.8101 67.4321L27.8101 67.2343L23.0273 67.2343Z",
    fill: "#004137"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 66.1718L22.9961 66.5674L27.7788 66.5674L27.7788 66.1718L22.9961 66.1718Z",
    fill: "#004137"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 65.7026L23.0273 65.9004L27.8101 65.9004L27.8101 65.7026L23.0273 65.7026Z",
    fill: "#004137"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 64.4664L22.9961 65.0845L27.7788 65.0845L27.7788 64.4664L22.9961 64.4664Z",
    fill: "#004137"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 63.3784L23.0273 63.5762L27.8101 63.5762L27.8101 63.3784L23.0273 63.3784Z",
    fill: "#004137"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 63.8227L23.0273 64.2183L27.8101 64.2183L27.8101 63.8227L23.0273 63.8227Z",
    fill: "#004137"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 62.5372L23.0273 63.1553L27.8101 63.1553L27.8101 62.5372L23.0273 62.5372Z",
    fill: "#004137"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 61.4745L23.0273 61.8701L27.8101 61.8701L27.8101 61.4745L23.0273 61.4745Z",
    fill: "#004137"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 61.0044L23.0273 61.2021L27.8101 61.2021L27.8101 61.0044L23.0273 61.0044Z",
    fill: "#004137"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 73.6225L22.9961 74.0181L27.7788 74.0181L27.7788 73.6225L22.9961 73.6225Z",
    fill: "#004137"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 73.1767L22.9961 73.3745L27.7788 73.3745L27.7788 73.1767L22.9961 73.1767Z",
    fill: "#004137"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 72.5341L22.9961 72.7319L27.7788 72.7319L27.7788 72.5341L22.9961 72.5341Z",
    fill: "#004137"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 71.4712L22.9961 71.6689L27.7788 71.6689L27.7788 71.4712L22.9961 71.4712Z",
    fill: "#004137"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 70.6298L22.9961 70.8276L27.7788 70.8276L27.7788 70.6298L22.9961 70.6298Z",
    fill: "#004137"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2236 53.491C20.2236 53.491 20.2517 53.4347 20.2799 53.4347L20.7447 53.4347C20.7447 53.4347 20.801 53.4628 20.801 53.491L20.801 55.1951C20.801 55.1951 20.7728 55.2655 20.7306 55.2655C19.3926 55.2515 18.5617 54.6459 18.5617 53.3783C18.5617 52.1671 19.3926 51.3784 20.6461 51.3784C21.8995 51.3784 22.7305 52.2094 22.7305 53.4628C22.7305 54.0966 22.5192 54.5613 22.1812 54.9134C22.153 54.9416 22.1249 54.9275 22.1108 54.9134L21.6601 54.5473C21.6601 54.5473 21.646 54.5191 21.646 54.505C21.646 54.4909 21.646 54.4768 21.6601 54.4628C21.815 54.2938 22.0404 53.9135 22.0404 53.4487C22.0404 52.6178 21.4911 52.0685 20.6602 52.0685C19.8292 52.0685 19.28 52.5896 19.28 53.3783C19.28 54.0262 19.6039 54.4346 20.2376 54.5473L20.2376 53.4769L20.2236 53.491Z",
    fill: "#9E8959"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7305 57.7861C22.7305 59.0395 21.8995 59.8564 20.6461 59.8564C19.3926 59.8564 18.5617 59.0395 18.5617 57.7861C18.5617 56.5326 19.3926 55.7017 20.6461 55.7017C21.8995 55.7017 22.7305 56.5326 22.7305 57.7861ZM19.2659 57.7861C19.2659 58.6029 19.8151 59.1663 20.6461 59.1663C21.477 59.1663 22.0263 58.617 22.0263 57.7861C22.0263 56.9551 21.477 56.4058 20.6461 56.4058C19.8151 56.4058 19.2659 56.9551 19.2659 57.7861Z",
    fill: "#9E8959"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2495 62.5335C19.2495 62.5335 19.2354 62.5898 19.1932 62.5898L18.6721 62.5898C18.6721 62.5898 18.6158 62.5617 18.6158 62.5335L18.6158 60.5759C18.6158 60.5759 18.6439 60.5195 18.6721 60.5195L22.6155 60.5195C22.6155 60.5195 22.6719 60.5477 22.6719 60.5759L22.6719 61.1674C22.6719 61.1674 22.6437 61.2237 22.6155 61.2237L19.2495 61.2237L19.2495 62.5335Z",
    fill: "#9E8959"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6158 63.2365C18.6158 63.2365 18.6439 63.1802 18.6721 63.1802L22.6155 63.1802C22.6155 63.1802 22.6719 63.2083 22.6719 63.2365L22.6719 64.4336C22.6719 65.673 21.8832 66.5039 20.6438 66.5039C19.4044 66.5039 18.6158 65.673 18.6158 64.4336L18.6158 63.2365ZM22.024 63.8844L19.2918 63.8844L19.2918 64.4336C19.2918 65.2646 19.827 65.8138 20.6579 65.8138C21.4888 65.8138 22.024 65.2646 22.024 64.4336L22.024 63.8844Z",
    fill: "#9E8959"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4432 26.188V13.5885C52.5551 11.7534 51.5704 9.33647 51.5704 7.61327C51.5704 5.89007 49.5563 6.00197 49.5563 6.00197H43.693H42.7754H36.9121C36.9121 6.00197 34.8979 5.89007 34.8979 7.61327C34.8979 9.33647 33.9133 11.7534 34.0252 13.5885V26.1656C34.0252 26.1656 33.6895 28.6945 35.9721 28.6945H42.753C43.3125 28.6945 43.6706 28.6945 43.6706 28.6945H50.4515C52.7565 28.6945 52.3985 26.1656 52.3985 26.1656L52.4432 26.188Z",
    fill: "#A971B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7141_4729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 18,
    height: 65
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M51.729 28.6499H34.7656V92.632H51.729V28.6499Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7141_4729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6202 22.2939H42.8593C39.1638 22.2939 36.168 25.2898 36.168 28.9853V84.3514C36.168 88.047 39.1638 91.0428 42.8593 91.0428H43.6202C47.3158 91.0428 50.3116 88.047 50.3116 84.3514V28.9853C50.3116 25.2898 47.3158 22.2939 43.6202 22.2939Z",
    fill: "white",
    stroke: "#555555",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2461 9.51562V25.0244",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4102 11.4175V25.024",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0547 11.4175V25.024",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6139 37.627H39.3008V80.2546H49.6139",
    stroke: "#A971B0",
    strokeWidth: 1.37509
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 50.975L45.0273 51.3706L49.8101 51.3706L49.8101 50.975L45.0273 50.975Z",
    fill: "#004137"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 50.5298L45.0273 50.7275L49.8101 50.7275L49.8101 50.5298L45.0273 50.5298Z",
    fill: "#004137"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 49.8867L45.0273 50.0845L49.8101 50.0845L49.8101 49.8867L45.0273 49.8867Z",
    fill: "#004137"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 48.8242L45.0273 49.022L49.8101 49.022L49.8101 48.8242L45.0273 48.8242Z",
    fill: "#004137"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 47.9829L45.0273 48.1807L49.8101 48.1807L49.8101 47.9829L45.0273 47.9829Z",
    fill: "#004137"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 46.9203L44.9961 47.3159L49.7788 47.3159L49.7788 46.9203L44.9961 46.9203Z",
    fill: "#004137"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 46.4506L45.0273 46.6484L49.8101 46.6484L49.8101 46.4507L45.0273 46.4506Z",
    fill: "#004137"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 45.2144L44.9961 45.8325L49.7788 45.8325L49.7788 45.2144L44.9961 45.2144Z",
    fill: "#004137"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 44.1269L45.0273 44.3247L49.8101 44.3247L49.8101 44.1269L45.0273 44.1269Z",
    fill: "#004137"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 44.5707L45.0273 44.9663L49.8101 44.9663L49.8101 44.5707L45.0273 44.5707Z",
    fill: "#004137"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 43.2857L45.0273 43.9038L49.8101 43.9038L49.8101 43.2857L45.0273 43.2857Z",
    fill: "#004137"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 42.2231L45.0273 42.6187L49.8101 42.6187L49.8101 42.2231L45.0273 42.2231Z",
    fill: "#004137"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 41.7524L45.0273 41.9502L49.8101 41.9502L49.8101 41.7524L45.0273 41.7524Z",
    fill: "#004137"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 60.601L45.0273 60.9966L49.8101 60.9966L49.8101 60.601L45.0273 60.601Z",
    fill: "#004137"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 60.1557L45.0273 60.3535L49.8101 60.3535L49.8101 60.1557L45.0273 60.1557Z",
    fill: "#004137"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 59.5131L45.0273 59.7109L49.8101 59.7109L49.8101 59.5132L45.0273 59.5131Z",
    fill: "#004137"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 58.4497L45.0273 58.6475L49.8101 58.6475L49.8101 58.4497L45.0273 58.4497Z",
    fill: "#004137"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 57.6093L45.0273 57.8071L49.8101 57.8071L49.8101 57.6093L45.0273 57.6093Z",
    fill: "#004137"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 56.5458L44.9961 56.9414L49.7788 56.9414L49.7788 56.5458L44.9961 56.5458Z",
    fill: "#004137"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 56.0771L45.0273 56.2749L49.8101 56.2749L49.8101 56.0771L45.0273 56.0771Z",
    fill: "#004137"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 54.8409L44.9961 55.459L49.7788 55.459L49.7788 54.8409L44.9961 54.8409Z",
    fill: "#004137"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 53.7534L45.0273 53.9512L49.8101 53.9512L49.8101 53.7534L45.0273 53.7534Z",
    fill: "#004137"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 54.1972L45.0273 54.5928L49.8101 54.5928L49.8101 54.1972L45.0273 54.1972Z",
    fill: "#004137"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 52.9117L45.0273 53.5298L49.8101 53.5298L49.8101 52.9117L45.0273 52.9117Z",
    fill: "#004137"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 51.849L45.0273 52.2446L49.8101 52.2446L49.8101 51.849L45.0273 51.849Z",
    fill: "#004137"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 51.3789L45.0273 51.5767L49.8101 51.5767L49.8101 51.3789L45.0273 51.3789Z",
    fill: "#004137"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 70.2265L45.0273 70.6221L49.8101 70.6221L49.8101 70.2265L45.0273 70.2265Z",
    fill: "#004137"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 69.7812L45.0273 69.979L49.8101 69.979L49.8101 69.7812L45.0273 69.7812Z",
    fill: "#004137"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 69.1386L45.0273 69.3364L49.8101 69.3364L49.8101 69.1386L45.0273 69.1386Z",
    fill: "#004137"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 68.0756L45.0273 68.2734L49.8101 68.2734L49.8101 68.0757L45.0273 68.0756Z",
    fill: "#004137"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 67.2343L45.0273 67.4321L49.8101 67.4321L49.8101 67.2343L45.0273 67.2343Z",
    fill: "#004137"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 66.1718L44.9961 66.5674L49.7788 66.5674L49.7788 66.1718L44.9961 66.1718Z",
    fill: "#004137"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 65.7026L45.0273 65.9004L49.8101 65.9004L49.8101 65.7026L45.0273 65.7026Z",
    fill: "#004137"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 64.4664L44.9961 65.0845L49.7788 65.0845L49.7788 64.4664L44.9961 64.4664Z",
    fill: "#004137"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 63.3784L45.0273 63.5762L49.8101 63.5762L49.8101 63.3784L45.0273 63.3784Z",
    fill: "#004137"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 63.8227L45.0273 64.2183L49.8101 64.2183L49.8101 63.8227L45.0273 63.8227Z",
    fill: "#004137"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 62.5372L45.0273 63.1553L49.8101 63.1553L49.8101 62.5372L45.0273 62.5372Z",
    fill: "#004137"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 61.4745L45.0273 61.8701L49.8101 61.8701L49.8101 61.4745L45.0273 61.4745Z",
    fill: "#004137"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0273 61.0044L45.0273 61.2021L49.8101 61.2021L49.8101 61.0044L45.0273 61.0044Z",
    fill: "#004137"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 73.6225L44.9961 74.0181L49.7788 74.0181L49.7788 73.6225L44.9961 73.6225Z",
    fill: "#004137"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 73.1767L44.9961 73.3745L49.7788 73.3745L49.7788 73.1767L44.9961 73.1767Z",
    fill: "#004137"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 72.5341L44.9961 72.7319L49.7788 72.7319L49.7788 72.5341L44.9961 72.5341Z",
    fill: "#004137"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 71.4712L44.9961 71.6689L49.7788 71.6689L49.7788 71.4712L44.9961 71.4712Z",
    fill: "#004137"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9961 70.6298L44.9961 70.8276L49.7788 70.8276L49.7788 70.6298L44.9961 70.6298Z",
    fill: "#004137"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0664 49.6267C41.0664 49.6267 41.0541 49.6704 41.0172 49.6704H40.5493C40.5493 49.6704 40.5 49.6486 40.5 49.6267V48.0437C40.5 48.0437 40.5246 48 40.5493 48H44.1201C44.1201 48 44.1694 48.0218 44.1694 48.0437V48.5131C44.1694 48.5131 44.1447 48.5568 44.1201 48.5568H41.0664V49.6158V49.6267Z",
    fill: "#A971B0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5616 49.8336L44.1324 51.0673C44.1324 51.0673 44.1817 51.1001 44.1817 51.1328V51.6241C44.1817 51.6241 44.1694 51.6787 44.1324 51.6896L40.5616 52.9233C40.5616 52.9233 40.5 52.9233 40.5 52.8906V52.4211C40.5 52.4211 40.5123 52.3775 40.5369 52.3775L41.4727 52.0499V50.7289L40.5369 50.4013C40.5123 50.4013 40.5 50.3795 40.5 50.3577V49.8773C40.5 49.8773 40.5246 49.8336 40.5616 49.8445V49.8336ZM42.0268 50.9036V51.8534L43.3936 51.3839L42.0268 50.9145V50.9036Z",
    fill: "#A971B0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1694 52.7931V53.2954C44.1694 53.2954 44.157 53.339 44.1324 53.3499L41.2757 54.2998L44.1324 55.2496C44.1324 55.2496 44.1694 55.2824 44.1694 55.3042V55.8064C44.1694 55.8064 44.1447 55.861 44.1078 55.8501L40.5493 54.6382C40.5493 54.6382 40.5 54.6055 40.5 54.5727V54.0159C40.5 54.0159 40.5123 53.9613 40.5493 53.9504L44.1078 52.7495C44.1078 52.7495 44.1694 52.7495 44.1694 52.7822V52.7931Z",
    fill: "#A971B0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5493 56.1881H44.1201C44.1201 56.1881 44.1694 56.21 44.1694 56.2318V58.0551C44.1694 58.0551 44.1447 58.0987 44.1201 58.0987H43.6276C43.6276 58.0987 43.5783 58.0769 43.5783 58.0551V56.7558H42.6795V57.8367C42.6795 57.8367 42.6548 57.8804 42.6302 57.8804H42.1377C42.1377 57.8804 42.0884 57.8585 42.0884 57.8367V56.7558H41.1034V58.1096C41.1034 58.1096 41.091 58.1533 41.0541 58.1533H40.5493C40.5493 58.1533 40.5 58.1424 40.5 58.1096V56.2427C40.5 56.2427 40.5246 56.199 40.5493 56.199V56.1881Z",
    fill: "#A971B0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5493 58.6665H44.1201C44.1201 58.6665 44.1694 58.6883 44.1694 58.7101V59.256C44.1694 59.256 44.157 59.2997 44.1324 59.3215L41.5343 60.7845H44.1201C44.1201 60.7845 44.1694 60.8063 44.1694 60.8282V61.2976C44.1694 61.2976 44.1447 61.3413 44.1201 61.3413H40.5493C40.5493 61.3413 40.5 61.3195 40.5 61.2976V60.7517C40.5 60.7517 40.5123 60.7081 40.5369 60.6972L43.1474 59.2233H40.5616C40.5616 59.2233 40.5123 59.2014 40.5123 59.1796V58.7101C40.5123 58.7101 40.5369 58.6665 40.5616 58.6665H40.5493Z",
    fill: "#A971B0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 62.0851C40.5 62.0851 40.5246 62.0415 40.5493 62.0415H44.1201C44.1201 62.0415 44.1694 62.0633 44.1694 62.0851V63.0459C44.1694 64.0503 43.4552 64.7163 42.3347 64.7163C41.2142 64.7163 40.5 64.0503 40.5 63.0459V62.0851ZM43.5783 62.5983H41.1034V63.0459C41.1034 63.7228 41.5836 64.1486 42.347 64.1486C43.1104 64.1486 43.5906 63.7119 43.5906 63.035V62.5983H43.5783Z",
    fill: "#A971B0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5453 65.2301H44.1162C44.1162 65.2301 44.1655 65.2519 44.1655 65.2738V67.0971C44.1655 67.0971 44.1408 67.1407 44.1162 67.1407H43.6237C43.6237 67.1407 43.5744 67.1189 43.5744 67.0971V65.7978H42.6755V66.8787C42.6755 66.8787 42.6509 66.9224 42.6263 66.9224H42.1338C42.1338 66.9224 42.0845 66.9005 42.0845 66.8787V65.7978H41.0994V67.1516C41.0994 67.1516 41.0871 67.1953 41.0502 67.1953H40.5453C40.5453 67.1953 40.4961 67.1844 40.4961 67.1516V65.2847C40.4961 65.2847 40.5207 65.241 40.5453 65.241V65.2301Z",
    fill: "#A971B0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5453 67.7068H44.1162C44.1162 67.7068 44.1655 67.7286 44.1655 67.7505V68.9077C44.1655 69.5628 43.7099 69.9558 43.0449 69.9558C42.5032 69.9558 42.0968 69.6829 41.9737 69.2244L40.5577 69.9995C40.5577 69.9995 40.4961 69.9995 40.4961 69.9668V69.4318C40.4961 69.4318 40.4961 69.399 40.5207 69.3881L41.9244 68.6675V68.2636H40.5577C40.5207 68.2636 40.5084 68.2418 40.5084 68.2199V67.7505C40.5084 67.7505 40.533 67.7068 40.5577 67.7068H40.5453ZM42.5278 68.9187C42.5278 69.1479 42.6755 69.3881 43.0449 69.3881C43.4143 69.3881 43.5744 69.1588 43.5744 68.9187V68.2745H42.5278V68.9187Z",
    fill: "#A971B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldLavTube);
export default __webpack_public_path__ + "static/media/gold_lav_tube.814d72916c4425425b2da54568b089bb.svg";
export { ForwardRef as ReactComponent };